import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { mediaQueries } from '../../../style/global-style';

export const StyledComponentWrapper = styled.section`
    color: ${(props) => props.theme.shades.blackGrey};
    margin: 0 auto;
    width: 100%;
    padding-bottom: 30px;

    @media ${mediaQueries.phone} {
        background-color: ${(props) => props.theme.shades.white};
        margin-bottom: ${({ theme }) => theme.spacing.landingComponent.small};
    }

    @media ${mediaQueries.tabletAndUp} {
        padding: 0 15px;
        margin-bottom: ${({ theme }) => theme.spacing.landingComponent.medium};
    }

    @media ${mediaQueries.desktopAndUp} {
        max-width: 1200px;
        margin-bottom: ${({ theme }) => theme.spacing.landingComponent.large};
    }
    h1 {
        padding-top: 20px;
    }
`;

export const StyledHighlightList = styled.ul`
    display: flex;
    flex-direction: column;
    list-style: none;
    padding-left: 0;
    padding-top: 10px;

    @media ${mediaQueries.tabletAndUp} {
        flex-direction: row;
        width: 100%;
        padding-top: 0;
    }
`;

export const StyledHighlightListItem = styled.li<{ align?: string }>`
    display: flex;
    font-weight: 700;
    align-items: center;
    padding: 3px 0;
    /* /custom fontsize */
    font-size: 15px;

    div {
        display: flex;
        align-items: center;
    }

    svg {
        fill: ${(props) => props.theme.colors.main4};
        flex-basis: 25px;
        height: 25px;
        width: 25px;
        margin-right: 8px;
    }

    div span {
        width: 100%;
    }

    @media ${mediaQueries.tabletAndUp} {
        width: 33%;
        justify-content: ${(props) => props.align};
        padding: 0;
    }
`;

export const StyledHighlightContainer = styled.div`
    width: 100%;
    background-color: ${(props) => props.theme.shades.white};

    @media ${mediaQueries.tabletAndUp} {
        margin-bottom: 15px;
        background-color: transparent;
    }
`;

export const StyledRatingWrapper = styled.div`
    display: flex;
    justify-content: space-evenly;
    background-color: ${(props) => props.theme.shades.white};

    @media ${mediaQueries.tablet} {
        padding-top: 20px;
    }
`;

export const StyledRatingInner = styled.div`
    width: 100%;
    padding: 40px 0 35px 0;

    @media ${mediaQueries.tabletAndUp} {
        width: 33%;
        padding: 40px 0 20px 0;
    }
`;

export const StyledTestimonialContainer = styled.div`
    display: none;

    @media ${mediaQueries.tabletAndUp} {
        display: flex;
        width: 66%;
        max-width: 66%;
        overflow: hidden;
        align-items: center;
    }
`;

// Bar Section
export const StyledBarSection = styled.div`
    display: flex;
    align-items: baseline;
    background-color: ${(props) => props.theme.shades.white};
    padding-top: 10px;

    @media ${mediaQueries.tablet} {
        padding: 20px 0px;
    }

    @media ${mediaQueries.smallDesktopAndUp} {
        padding: 10px 15px 0;
    }
`;

export const StyledBarContainer = styled.div`
    width: 50%;
    max-width: 50%;
    padding-left: 10px;
    padding-right: 10px;
    flex-grow: 1;

    @media ${mediaQueries.smallDesktopAndUp} {
        padding-left: 15px;
        padding-right: 15px;
    }
`;

export const StyledOverviewContainer = styled.div`
    display: block;
    width: 50%;

    ${StyledBarContainer} {
        width: 100%;
        max-width: 100%;
    }

    @media ${mediaQueries.smallDesktopAndUp} {
        width: 33%;
    }
`;

export const StyledDetailContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 20px;

    width: 50%;
    padding-bottom: 0;

    ${StyledBarContainer} {
        width: 100%;
        max-width: 100%;
    }

    @media ${mediaQueries.smallDesktopAndUp} {
        width: 66%;
        padding-bottom: 0;
        ${StyledBarContainer} {
            width: 50%;
            max-width: 50%;
            &:nth-child(2n) {
                padding-right: 5px;
            }
        }
    }
`;

// The load more button wrapper
// @TODO move it outside that we can reuse
export const StyledButtonWrapper = styled.div<{ arrow?: string }>`
    display: flex;
    justify-content: center;

    button {
        @media ${mediaQueries.tabletAndUp} {
            min-width: 170px;
        }
    }

    svg {
        ${(props) => {
            return (
                props.arrow !== 'right' &&
                css`
                    transform: rotate(90deg);
                    /* Since we have svg inside svg, Firefox will rotate both */
                    svg {
                        transform: rotate(0);
                    }
                `
            );
        }}
        @media ${mediaQueries.phone} {
            width: 13px;
        }
    }

    @media ${mediaQueries.tabletAndUp} {
        background-color: ${(props) => props.theme.shades.white};
        padding-bottom: 30px;
    }
`;

export const StyledSpinnerWrapper = styled.div`
    text-align: center;
    padding: ${(props) => props.theme.spacing.xxxLarge} 0;
`;
